import { css } from '@emotion/react';
import { Dialog, semanticTokens, tokens } from '@flysas-tech/commercial-ui';
import { Dispatch, ReactElement, SetStateAction, useState } from 'react';

import { LinkAsButton } from '../atoms';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${tokens.dimension['space-4']};
  `,
  priceDetail: css`
    font-size: ${tokens.fontSize.paragraph['paragraph-2']};
    color: ${semanticTokens.color.text.primary};
    display: flex;
    justify-content: space-between;
  `,
};

type PriceDetail = {
  label: string;
  price: string;
  breakdown?: ReactElement;
};

type Props = {
  priceDetails: PriceDetail[];
  handleOpen?: Dispatch<SetStateAction<boolean>>;
  pos: string;
};

export function PriceDetailsList({ priceDetails }: Props) {
  const [selectedBreakdown, selectBreakdown] = useState<{ title: string; component: ReactElement } | undefined>(
    undefined
  );
  return (
    <>
      <dl css={styles.container}>
        {priceDetails.map(({ label, price, breakdown }) => {
          return (
            <div key={label} css={styles.priceDetail}>
              {breakdown ? (
                <LinkAsButton onClick={() => selectBreakdown({ title: label, component: breakdown })}>
                  {label}
                </LinkAsButton>
              ) : (
                <dt>{label}</dt>
              )}
              <dd>{price}</dd>
            </div>
          );
        })}
      </dl>
      {selectedBreakdown && (
        <Dialog.Root>
          <Dialog.Window
            onCloseLabel="Close"
            closeOnEscape
            onClose={() => selectBreakdown(undefined)}
            title={selectedBreakdown.title}
          >
            <Dialog.Container>{selectedBreakdown.component}</Dialog.Container>
          </Dialog.Window>
        </Dialog.Root>
      )}
    </>
  );
}
